import { render, staticRenderFns } from "./ValidadeVencida.vue?vue&type=template&id=c251ac02&"
import script from "./ValidadeVencida.vue?vue&type=script&lang=js&"
export * from "./ValidadeVencida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports